import React, { ReactNode, createContext, useContext } from "react";

import type { Device } from "../model";

export const BULK_ACTIONS = {
  CANCEL_PENDING_UPGRADE: "cancelPending",
  DELETE: "deleteDevices",
  REGISTER_BULK: "registerBulkDevices",
  REGISTER_SINGLE: "registerSingleDevice",
  RESTART: "restartDevices",
  STRATEGY: "updateStrategy",
  UP_DOWNGRADE_PLAYER: "upDowngradePlayer",
  UPGRADE_AGENT: "upgradeAgent",
  UPGRADE_FIRMWARE: "upgradeFirmware",
} as const;

export type BulkAction = (typeof BULK_ACTIONS)[keyof typeof BULK_ACTIONS];

interface DeviceTableActionsValue {
  openBulkAction: (action: BulkAction, item?: Device) => void;
  openUpgradeForDevice: (device: Device) => void;
  openAgentUpgradeForDevice: (device: Device) => void;
  openFirmwareUpgradeForDevice: (device: Device) => void;
  openRestartForDevice: (device: Device) => void;
  openDeleteForDevice: (device: Device) => void;
  openCancelPendingForDevice: (device: Device) => void;
}

const DeviceTableActionsContext = createContext<DeviceTableActionsValue | null>(
  null,
);

export function DeviceTableActionsProvider({
  value,
  children,
}: {
  value: DeviceTableActionsValue;
  children: ReactNode;
}) {
  return (
    <DeviceTableActionsContext.Provider value={value}>
      {children}
    </DeviceTableActionsContext.Provider>
  );
}

export function useDeviceTableActions(): DeviceTableActionsValue {
  const ctx = useContext(DeviceTableActionsContext);
  if (!ctx) {
    throw new Error(
      "useDeviceTableActions must be used within DeviceTableActionsProvider",
    );
  }
  return ctx;
}
